import { Component } from '@angular/core';

import { Subject } from 'rxjs';

import {
  CamCalendarNoteFormService,
  CamCreateEventSelectionComponent,
  CamUnavailabilityFormService,
  CreateNoteFormComponent,
  CreateUnavailabilityFormComponent,
  EventFormComponent,
  PlanningVisitFormService,
} from '@camelot/planning';

import { TestIdDirective } from '@camelot/testing-harness';

const visitFormServiceFake: PlanningVisitFormService = {
  formatEventForm: () => [],
  getEventForm: () => [],
};

const noteFormServiceMock = {
  formatEventForm: () => ({}),
  formatUpdateForm: () => ({}),
  getEditForm: () => [],
  getEventForm: () => [],
  getFields: () => [],
};

const unavailabilityFormServiceMock = {
  formatEventForm: () => ({}),
  formatUpdateForm: () => ({}),
  getEventForm: () => [],
  getFields: () => [],
};

@Component({
    imports: [
        CamCreateEventSelectionComponent,
        CreateNoteFormComponent,
        CreateUnavailabilityFormComponent,
        EventFormComponent,
        TestIdDirective,
    ],
    providers: [
        { provide: CamCalendarNoteFormService, useValue: noteFormServiceMock },
        { provide: CamUnavailabilityFormService, useValue: unavailabilityFormServiceMock },
    ],
    template: `
    <cam-create-note-form camTestId="cam-create-note-form" [askValidation]="this.askValidation" />
    <cam-create-unavailability-form
      camTestId="cam-create-unavailability-form"
      [askValidation]="this.askValidation"
    />
    <cam-visit-event-form
      camTestId="cam-visit-event-form"
      [formService]="this.visitFormService"
      [askValidation]="this.askValidation"
    />
    <cam-create-event-selection camTestId="cam-create-event-selection" [formService]="this.visitFormService" />
  `
})
export class PlanningFormsCase {
  public askValidation = new Subject<null>();
  public visitFormService = visitFormServiceFake;
}
